import React from "react";

import {
    AiFillCode,
    AiFillHome,
    AiOutlineGithub
} from "react-icons/ai";

import {BsStarFill} from "react-icons/bs";
import {MdWork} from "react-icons/md";


const menuConfig = {

    sidebarData: [
        {
            id: "menu-0",
            title: "Experience Timeline",
            path: "/portfolio",
            icon: <MdWork size={35}/>,
            className: "nav-text"
        },
        {
            id: "menu-1",
            title: "Projects",
            path: "/projects",
            icon: <AiOutlineGithub size={35}/>,
            className: "nav-text"
        },
        {
            id: "menu-3",
            title: "Skills",
            path: "/skills",
            icon: <AiFillCode size={35}/>,
            className: "nav-text"
        },
        {
            id: "menu-2",
            title: "Leadership",
            path: "/leadership",
            icon: <BsStarFill size={35}/>,
            className: "nav-text"
        }
    ]

}

export default menuConfig
